import Button, { ButtonProps } from "@mui/material/Button";
import Box from "@mui/material/Box";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import { useState } from "react";

export default function ConfirmationPopover({
  buttonLabel,
  buttonProps,
  onConfirm,
  confirmText = "Confirm",
  cancelText = "Cancel",
}: {
  buttonLabel?: string;
  buttonProps?: ButtonProps;
  onConfirm?: () => void;
  cancelText?: string;
  confirmText?: string;
}) {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleConfirm = () => {
    if (onConfirm) onConfirm();
    handleClose();
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <Button
        variant="outlined"
        color="error"
        {...buttonProps}
        onClick={(e) => {
          setAnchorEl(e.currentTarget);
        }}
      >
        {buttonLabel}
      </Button>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <Box p={2}>
          <Typography variant="subtitle1" gutterBottom>
            Are you sure?
          </Typography>
          <Stack direction="row" spacing={1} justifyContent="flex-end">
            <Button onClick={handleClose} size="small">
              {cancelText}
            </Button>
            <Button
              onClick={handleConfirm}
              size="small"
              color="error"
              variant="contained"
            >
              {confirmText}
            </Button>
          </Stack>
        </Box>
      </Popover>
    </>
  );
}
